import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Title } from "react-admin";
import { Tasks } from "../../../crewApp/pages/myTasks/MyTasks";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    // marginTop: theme.spacing(1),
  },
}));

export const CrewDashboard = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Title title=" " />
      <Grid container spacing="2">
        <Grid item xs={12}>
          <Tasks {...props} hideTitle={true} redirectTo="/" />
        </Grid>
      </Grid>
    </div>
  );
};
